const referenceHelper = {
    /* A function that takes two parameters, id and formTypes. It returns an object with a property called
    Type. */
    getFormTypeRefDataById: (id: number, formTypes: Array<{ CustomFormTypeId: number, Type: string }>) => {
        const refData = formTypes.filter(obj => {
            return obj.CustomFormTypeId === id
        })[0]
        return refData || { Type: "Choose type" }
    }
}
export default referenceHelper